import { RootState } from '../../store/store';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { IBasicAdInformation, ISponsoredAdInformation, ISponsoredAds } from '../../types/manage';
import { indexedDBService } from '../../services/indexdb-service';
import { GetAdForDisplaying, UpdateAdViewCount, UpdateAdClickCount } from '../../services/user-service';
import { RoleEnum } from '../../types/enums';
import { useDispatch } from 'react-redux';
import { updateSubmissionDialog } from '../../store/submissionDialogState';

export const BannerAd = () => {
    const user = useSelector((state: RootState) => state.userDetail);
    const [bannerInfo, setBannerInfo] = useState<IBasicAdInformation>();
    const [currentBanner, setCurrentBanner] = useState<ISponsoredAds>();
    const [isLoading, setIsLoading] = useState(false);
    const url = window.location.pathname.split('/').pop();
    const SubmissionState = useSelector((state: RootState) => state.submissionDialog);
    const dispatch = useDispatch();
    const [runURLPath, setRunURLPath] = useState(true);
    const [prevURL, setPrevURL] = useState<string | undefined>();

    const getAdForDisplaying = async (slotNumber?: number) => {
        try {
            const response = await GetAdForDisplaying(slotNumber);
            setCurrentBanner(response);
            return response;
        } catch (error) {
        }
    }

    const getBannerInfoFromIndexDb = async (slotNumber?: number) => {
        try {
            if (await indexedDBService.validateStoreName("Ad") && await indexedDBService.getItem("Ad", "Ad")) {
                const response = await indexedDBService.getItem("Ad", "Ad");
                setBannerInfo(response);
                return response;
            }
            setBannerInfo({
                slotNumber: slotNumber ? slotNumber : undefined,
                viewCount: 0
            }
            )
            return {
                slotNumber: slotNumber ? slotNumber : undefined,
                viewCount: 0
            };
        } catch (error) {
        }
    }

    const updateViewCount = async (sponsoredAdId: number) => {
        try {
            await UpdateAdViewCount(sponsoredAdId);

        } catch (error) {
        }
    }

    const incrementViews = (ad: IBasicAdInformation) => {
        try {
            const incremented: IBasicAdInformation = {
                slotNumber: ad.slotNumber,
                viewCount: ad.viewCount + 1
            }
            return incremented;
        }
        catch (error) {
        }
    }

    const syncSlotNumbers = (adInfo: IBasicAdInformation, dbAdInfo: ISponsoredAdInformation) => {
        const combinedInfo: IBasicAdInformation = {
            slotNumber: dbAdInfo.slotNumber,
            viewCount: adInfo.viewCount
        }
        return combinedInfo;
    }

    const handleBannerView = async () => {
        try {
            setIsLoading(true);
            let bannerData: IBasicAdInformation = await getBannerInfoFromIndexDb();
            let banner;
            if (bannerData.slotNumber) {
                banner = await getAdForDisplaying(bannerData.slotNumber);
            }
            else {
                banner = await getAdForDisplaying();
            }
            if (bannerData && banner) {
                bannerData = syncSlotNumbers(incrementViews(bannerData) as IBasicAdInformation, banner.sponsoredAdInformation);
                if (bannerData.viewCount > 1) {
                    handleBannerChange(banner.sponsoredAdInformation.slotNumber);
                }
                else {
                    updateViewCount(banner.sponsoredAdInformation.id);
                    await indexedDBService.setItem("Ad", "Ad", bannerData);
                    setIsLoading(false);
                }
            }
        } catch (error) {
            setIsLoading(false);
        }
    };

    const handleBannerChange = async (slot: number) => {
        await indexedDBService.setItem("Ad", "Ad", { slotNumber: slot + 1, viewCount: 0 });
        handleBannerView();
    }

    const handleAdClick = async () => {
        if (currentBanner?.sponsoredAdInformation) {
            await UpdateAdClickCount(currentBanner.sponsoredAdInformation.id);
            window.open(currentBanner.sponsoredAdInformation.adUrl as string, '_blank');
        }
    }

    useEffect(() => {
        if (runURLPath || prevURL !== "redirect") {
            setRunURLPath(false);
            handleBannerView();
            setPrevURL(url);
        }
        else {
            setRunURLPath(true);
        }
    }, [url]);

    useEffect(() => {
        if (SubmissionState.isOpen === true) {
            handleBannerView();
            dispatch(updateSubmissionDialog({ isOpen: false }));
        }
    }, [SubmissionState]);

    return (
        <div>
            {user.roleId >= RoleEnum.CredentialingManager && currentBanner && !isLoading &&
                <img
                    id={`ad-${currentBanner.sponsoredAdInformation.id}`}
                    src={`data:${currentBanner.sponsoredAd.contentType};base64,${currentBanner.sponsoredAd.fileContents}`}
                    alt={`Ad ${currentBanner.sponsoredAdInformation.name}`}
                    style={{ maxWidth: '728px', maxHeight: '90px' }}
                    onClick={handleAdClick}
                />
            }
        </div>
    );
}

